export const UNIQUE_CONFIG_KEY = 'subscriptions-frontend';
